(() => {
  if (customElements.get('broek-recently-viewed')) return;
  const historyKey = 'broek_recently_viewed_handles';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const normalize = value => Array.isArray(value) ? [...new Set(value.filter(validHandle))].slice(0, 25) : [];
  function readHistory() {
    try { return normalize(JSON.parse(localStorage.getItem(historyKey))); }
    catch (_) { return []; }
  }
  function recordVisit(handle) {
    const history = readHistory();
    if (!validHandle(handle)) return history;
    const next = [handle, ...history.filter(item => item !== handle)].slice(0, 25);
    try { localStorage.setItem(historyKey, JSON.stringify(next)); }
    catch (_) { /* Browsers that block storage can still render any readable history. */ }
    return next;
  }
  class BroekRecentlyViewed extends SlideSection {
    init() {}
    connectedCallback() {
      this.container = this.closest('[data-broek-recently-container]');
      this.items = this.querySelector('[data-broek-recently-items]');
      if (!this.container || !this.items) return;
      this.onStorage = event => { if (event.key === historyKey || event.key === null) this.load(readHistory()); };
      this.onPageShow = event => { if (event.persisted) this.load(recordVisit(this.dataset.currentHandle)); };
      window.addEventListener('storage', this.onStorage);
      window.addEventListener('pageshow', this.onPageShow);
      this.load(recordVisit(this.dataset.currentHandle));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.version = (this.version || 0) + 1;
      window.removeEventListener('storage', this.onStorage);
      window.removeEventListener('pageshow', this.onPageShow);
      this.globalSlide?.destroy?.(true, true);
    }
    async load(history) {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const version = this.version = (this.version || 0) + 1;
      this.container.hidden = true;
      this.globalSlide?.destroy?.(true, true);
      this.globalSlide = null;
      this.removeAttribute('data-carousel-failed');
      this.items.replaceChildren();
      const limit = Math.max(1, Math.min(12, Number(this.dataset.limit) || 8));
      const handles = normalize(history).filter(handle => handle !== this.dataset.currentHandle).slice(0, limit);
      if (!handles.length) return;
      const cards = await Promise.all(handles.map(async handle => {
        try {
          const root = new URL(this.dataset.rootUrl || '/', location.origin);
          if (root.origin !== location.origin) return null;
          const url = new URL('products/' + encodeURIComponent(handle), root);
          url.searchParams.set('section_id', 'products-recently-viewed');
          const response = await fetch(url.href, { credentials: 'same-origin', signal });
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const template = Array.from(html.querySelectorAll('template[data-broek-recently-card]'))
            .find(item => item.dataset.productHandle === handle);
          const card = template?.content.querySelector('.product-item, .bv3-card');
          if (!card) return null;
          const node = card.cloneNode(true);
          if (node.classList.contains('swiper-slide')) return node;
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.append(node);
          return slide;
        } catch (_) { return null; }
      }));
      if (signal.aborted || !this.isConnected || version !== this.version) return;
      const present = cards.filter(Boolean);
      if (!present.length) return;
      this.items.append(...present);
      this.container.hidden = false;
      try { this.initSlide(); }
      catch (error) { this.setAttribute('data-carousel-failed', ''); console.error(error); }
      try { BlsLazyloadImg.init(); } catch (error) { console.error(error); }
    }
  }
  customElements.define('broek-recently-viewed', BroekRecentlyViewed);
})();
